// extracted by mini-css-extract-plugin
export default {"title":"FifthScreen_title__-1VN7","description":"FifthScreen_description__0GCHu","row":"FifthScreen_row__nQrrD","painSection":"FifthScreen_painSection__sqdVs"};